import styled from "styled-components";
import {SearchInputAreaDefaultBox} from "./search-input-area.default.box";

export const SearchInputAreaMrGreenBox = styled(SearchInputAreaDefaultBox)`
    border: 2px solid ${props => props.theme.colors.textMiddleDark};
    font-weight: 300;
    
    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        padding: 0.85rem 1rem 0.85rem 2.6rem;
        width: 0;
        &:focus {
            padding-left: 5rem;
        }
    }
    
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding: 1.2rem 5rem;
        /* padding: 1.2rem 1.2rem 1.2rem 5.7rem; */
        border-width: 1px;
    }
`;
